// extracted by mini-css-extract-plugin
module.exports = {"detailsBox":"_eb2e57b","modal":"_d2e9244","featured":"_8998607","item":"_8da43e2","yourInfo":"_d1163d1","gameItemTime":"_ec6d5b4","info":"_4dfd6b6","completed":"_01f0fd6"};